import React, { useState } from "react";
import { FaIcon } from "../../../lib/FaIcon";
import "./accordian.css";

export const Accordian = ({ defaultOpen, title, children, showCaret = true }) => {
  const [isOpen, setOpen] = useState(defaultOpen);
  const icon = isOpen ? "fa fa-chevron-up" : "fa fa-chevron-down";

  return (
    <section>
      <h4 className="m-0 pb-1 font-weight-lighter cursor-pointer " onClick={() => setOpen(!isOpen)}>
        {showCaret && <FaIcon icon={icon} />}
        {title}
      </h4>
      <div className={`accordian-collapsed ${isOpen ? "show" : ""}`}>{children}</div>
      <hr className="m-2 p-0" />
    </section>
  );
};
